
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facturacion",
      function () {
        return require("private-next-pages/facturacion/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facturacion"])
      });
    }
  